module.exports = __webpack_public_path__ + "static/media/Scratch.87fa82d4.svg";